/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Users_Invite_SkippedInputs */

const cs_users_invite_skipped = /** @type {(inputs: Users_Invite_SkippedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Přeskočeno (neaktivní / bez e-mailu / bez oprávnění): ${i?.count}`)
};

const en_users_invite_skipped = /** @type {(inputs: Users_Invite_SkippedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Skipped (inactive / no e-mail / not allowed): ${i?.count}`)
};

/**
* | output |
* | --- |
* | "Skipped (inactive / no e-mail / not allowed): {count}" |
*
* @param {Users_Invite_SkippedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const users_invite_skipped = /** @type {((inputs: Users_Invite_SkippedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Invite_SkippedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_invite_skipped(inputs)
	return cs_users_invite_skipped(inputs)
});